import React, { useState } from "react";
import { Tab, Button } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import {
  ListSimulators,
  SimulatorForm,
} from "../../../../components/Admin/Educasimulator";
import "./Simulators.scss";

export function Simulators() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prev) => !prev);
  const onReload = () => setReload((prev) => !prev);

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListSimulators reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="simulators-page">
        <div className="simulators-page__add">
          <Button primary onClick={onOpenCloseModal}>
            Nuevo Simulador
          </Button>
        </div>
        <Tab menu={{ secondary: true }} panes={panes} />
      </div>

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Crear nuevo simulador"
      >
        <SimulatorForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  );
}
